var WhatsappWidgetJs = (function ($) {

    function initialize() {
        var whatsappWidgetBtn = $(".whatsapp-widget-wrapper .whatsapp-widget-btn");
        if (!whatsappWidgetBtn.length) {
            return;
        }

        var whatsappFrame = $(".whatsapp-widget-wrapper .whatsapp-frame");
        if (!whatsappFrame.length) {
            return;
        }

        whatsappWidgetBtn.on("click", function () {
            var whatsappContent = whatsappFrame.children(".whatsapp-widget-content");
            $.fancybox({
                content: whatsappContent,
                maxWidth: 550,
                minHeight: 300,
                maxHeight: window.height,
                autoHeight: true,
                autoSize: true,
                helpers: {
                    overlay: {
                        locked: false
                    }
                }
            });
        })
    }

    return {
        initialize: initialize
    }
})($);


$(function () {
    WhatsappWidgetJs.initialize();
});